
import { useState } from "react";
import { BasicResponse } from "../api/models/schema";
//import { useAuth0 } from "@auth0/auth0-react";

export function useApi(apiFunc: any) {
  const [data, setData] = useState<any | undefined>(undefined);
  const [status, setStatus] = useState<number | undefined>(undefined);
  const [error, setError] = useState<BasicResponse | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  //const { getAccessTokenSilently } = useAuth0();

  const request = async (...args: any[]) => {
    setLoading(true);
    setStatus(undefined);
    setError(undefined);
    try {
      //let accessToken = await getAccessTokenSilently({ audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`, });
      let accessToken = "abc123FF";

      const result = await apiFunc(accessToken,...args);

      if (result) {
        setStatus(200);
        setData(result);
      }
    } catch (error: any) {
      if (error.response?.status) {
        setStatus(error.response.status);
      }

      if (error.response?.data) {
        var errorItem = error.response.data as BasicResponse;
        setError(errorItem);
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    status,
    data,
    error,
    loading,
    request,
  };
}
